<div class='container-tab'>
  <form #f="ngForm" class="form-container">

    <div class="scrollable-container">
      <div class="">
        <recent-file *ngFor="let file of recentFiles$ | async as files"
          [playlist]="playlist"
          [File]="file"
          [files]="files"
          [launchers]="launchers"
          [playlistItems]="playlistItems"
          [checkedPlaylists]="checkedPlaylists"
          [hasRssForegroundItem]="hasRssForegroundItem"
          (isCheckedEvent)="calculateSelectedPlaylists($event)"
          (changeLauncher)="onLauncherChange($event.launcher, false, $event.item)"
          (setDurationForAllItems)="onSetDurationForAllItems($event, file)"
          (changeSourceField)="onChangeSourceField($event)"
          (changeSourceData)="onChangeSourceData($event)"
          (changeMCLMode)="onChangeMode($event)"
          (determineDuration)="onDetermineDuration($event)"
          (setSelectedLauncherForAllItems)="onSetLauncherForAllItems($event, playlistItemTypes.RecentFile)"
          (zoomInputChanged)="onZoomInputChanged($event.event, $event.item.PlaylistItemLinks[$event.sourceId])"
          (stretchContentChanged)="onStretchContentChanged($event)"
          (setLauncherByFileType)="setLauncherBasedOnFileType($event)">
        </recent-file>
      </div>
    </div>

    <mat-toolbar class="tab-footer">
      <mat-checkbox *ngIf="!playlistItem.Id" [disableRipple]="true" [(ngModel)]="addAnother" name="addAnother"
        class="light">Add Another</mat-checkbox>

      <button type="button" (click)="cancel()" mat-raised-button mat-flat-button matTooltip="Cancel">Cancel</button>
      <button type="submit" (click)="submit()" [disabled]="checkedPlaylists < 1 || (playlistItems | isAnyPlaylistItemProcessing: timeSpan)" mat-flat-button matTooltip="Save">Save</button>

    </mat-toolbar>

  </form>
</div>
